export default class BlogPost {

  id: number
  author: string
  contact: string
  publishedAt: string

  titleEn: string
  contentEn: string
  titleDe: string
  contentDe: string
  titleJp: string
  contentJp: string

  preselectedLanguage?: string

  constructor (attributes?) {
    Object.assign(this, attributes)
  }

  getLanguages (): string[] {
    let languages: string[] = []
    if (this.contentEn) {
      languages.push('En')
    }
    if (this.contentDe) {
      languages.push('De')
    }
    if (this.contentJp) {
      languages.push('Jp')
    }
    return languages
  }
}
